<div class="d-flex flex-column min-vh-100">
    <main class="flex-grow-1 container">
        <router-outlet></router-outlet>
    </main>
</div>